import { isAdultDob } from './ageGate';

/**
 * B2 · Age-assurance provider interface. One contract, swappable adapters —
 * pick the vendor later without touching call sites.
 */
export interface AgeAssuranceResult {
  verified: boolean;
  /** Recorded so prod can later require a stronger method than attestation. */
  method: string;
}

export interface AgeAssuranceProvider {
  readonly name: string;
  assure(input: { dob: string }): Promise<AgeAssuranceResult>;
}

/**
 * Interim provider: self-attested DOB ≥ 18. Weak (no ID), but the method is
 * recorded ('dob_attestation') so a prod policy can later demand a stronger
 * provider (Persona IDV / age-estimation) before honouring 'verified'.
 */
export const dobAttestationProvider: AgeAssuranceProvider = {
  name: 'dob_attestation',
  assure: async ({ dob }) => ({ verified: isAdultDob(dob), method: 'dob_attestation' }),
};

// Persona / age-estimation adapters slot in here, selected by config/env.
export const getAgeProvider = (): AgeAssuranceProvider => dobAttestationProvider;
